var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { map, pickBy } from 'lodash';
import getProjectIdFromURL from 'app/core/utils/getProjectIdFromURL';
import { permission } from 'app/containers/Permissions';
import { TableTasks } from 'app/pages/Project/Tasks/TableTasks';
import { getResources } from 'app/store/selectors';
import { getSubResources } from 'app/store/resources/utils/getSubResources';
import { setActiveTableId } from 'app/store/reducers/tablesPrefs';
import { fetchTasksByAsset, resetTableTasks } from 'app/store/reducers/tasks';
import { resetReduxTableFilters, setAndApplyInputFilters } from 'app/store/reducers/tablesFilters';
import { flattenAllTakesByTableFromTasksSelector, tasksByTableSelector } from 'app/store/selectors/tasks';
import { tableUserPrefsDataSelector, tableUserPrefsSortBySelector } from 'app/store/selectors/tableUserPrefs';
import { tableFiltersDataSelector, tableFiltersForQueriesSelector } from 'app/store/selectors/tablesFilters';
import { getAssetsAttributValues } from 'app/store/selectors/getAssetsAttributValues';
import { Filters as DefaultFilters } from 'app/pages/Project/Tasks/Filters.js';
import { useProgress } from 'app/hooks/useProgress.js';
import allRequests from 'app/containers/Assets/AssetDetail/Tasks/tasksRequests';
import { filtersToURL } from 'app/components/Table/hooks/useFiltersUtils.js';
import { getURLParamsKey } from 'app/components/Table/utils.js';
import { urlToFilters, filtersToQueries } from 'app/components/Table/hooks/useFiltersUtils.js';
import routerHistory from 'app/main/routerHistory.js';
import { userPrefLocalResource } from 'app/core/utils/localUserPrefs.js';
export const tableId = 'AssetDetailsTableTask';
function Tasks(props) {
    var _a, _b, _c, _d;
    const { asset, localRouter: { config: { rightPanel }, }, } = props;
    const uniqTableId = `${tableId}${rightPanel ? '-rightPanel' : ''}`;
    const dispatch = useDispatch();
    const { search } = useLocation();
    const { initProgresses, updateProgress, progress } = useProgress();
    const projectId = asset.project || getProjectIdFromURL();
    const [page, setPage] = useState(0);
    const [requestsLoading, setRequestsLoading] = useState(true);
    const [filtersloading, setFiltersLoading] = useState(true);
    const table = (_a = userPrefLocalResource.getData('tables')) === null || _a === void 0 ? void 0 : _a[uniqTableId];
    const sortBy = useSelector(tableUserPrefsSortBySelector(uniqTableId));
    const tableUserPrefs = useSelector(tableUserPrefsDataSelector(uniqTableId));
    const { count = 0, loading = true, httpProgress = 0 } = (_b = useSelector(tasksByTableSelector(uniqTableId))) !== null && _b !== void 0 ? _b : {};
    const tasksData = useSelector(flattenAllTakesByTableFromTasksSelector(uniqTableId));
    const filtersData = (_c = useSelector(tableFiltersDataSelector(uniqTableId))) !== null && _c !== void 0 ? _c : [];
    const filtersForQueries = useSelector(tableFiltersForQueriesSelector(uniqTableId));
    const ordering = useSelector((state) => { var _a, _b, _c; return (_c = (_b = (_a = state.tablesPrefs.data) === null || _a === void 0 ? void 0 : _a[uniqTableId]) === null || _b === void 0 ? void 0 : _b.sortBy) === null || _c === void 0 ? void 0 : _c.orderingString; });
    const categories = ((_d = getAssetsAttributValues(undefined, 'category')) === null || _d === void 0 ? void 0 : _d.values) || [];
    const projects = getResources(undefined, 'assets', { assetType: 'pj' });
    const episodes = useSelector((state) => pickBy(state.assets.resources, (asset) => asset.assetType === 'ep' && asset.project === getProjectIdFromURL()));
    const progressionStatus = useSelector((state) => state.progressionStatus.resources);
    const assetsAttributes = map(getResources(undefined, 'attributes', projectId ? { project: projectId } : undefined));
    const steps = () => {
        const stepProjects = getResources(undefined, 'stepProjects', projectId ? { project: projectId } : undefined, [
            'stepInst',
        ]);
        if (projectId)
            return getSubResources(stepProjects, 'stepInst');
        return getResources(undefined, 'steps');
    };
    const filters = useMemo(() => {
        if (!requestsLoading) {
            const filt = new DefaultFilters({
                episodes,
                categories,
                progressionStatus,
                assetsAttributes,
                projects,
            }).getFilters();
            return filt;
        }
    }, [requestsLoading]);
    const getProgressAverage = (progresses) => {
        const values = Object.values(progresses);
        const progressAverage = values.reduce((acc, val) => acc + val) / values.length;
        return progressAverage;
    };
    useEffect(() => {
        dispatch(setActiveTableId(uniqTableId));
        (() => __awaiter(this, void 0, void 0, function* () {
            initProgresses();
            yield allRequests({ projectId });
            setRequestsLoading(false);
        }))();
        return () => {
            dispatch(resetTableTasks(uniqTableId));
        };
    }, []);
    useEffect(() => {
        ;
        (() => __awaiter(this, void 0, void 0, function* () {
            if (search && (filters === null || filters === void 0 ? void 0 : filters.length) && filtersloading) {
                const params = new URLSearchParams(search);
                const urlCurrentFilters = params.get(getURLParamsKey('filters', uniqTableId));
                if (urlCurrentFilters) {
                    const urlFilters = yield urlToFilters(urlCurrentFilters, filters, undefined, undefined, false);
                    dispatch(setAndApplyInputFilters({ tableId: uniqTableId, value: urlFilters }));
                }
                setFiltersLoading(false);
            }
            if (!search && (filters === null || filters === void 0 ? void 0 : filters.length) && (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length)) {
                dispatch(resetReduxTableFilters(uniqTableId));
                setFiltersLoading(false);
            }
            else if (!search && (filters === null || filters === void 0 ? void 0 : filters.length)) {
                setFiltersLoading(false);
            }
        }))();
    }, [filters]);
    useEffect(() => {
        const url = filtersToURL(filtersData);
        routerHistory.updateQuery({ [getURLParamsKey('filters', uniqTableId)]: url || null });
    }, [filtersData]);
    useEffect(() => {
        if (!requestsLoading && !filtersloading) {
            const { queries: filtQueries } = filtersToQueries(filtersForQueries !== null && filtersForQueries !== void 0 ? filtersForQueries : []);
            const queries = Object.assign({ page_size: (tableUserPrefs === null || tableUserPrefs === void 0 ? void 0 : tableUserPrefs.pageSize) || (table === null || table === void 0 ? void 0 : table.pageSize) || 50, page: page + 1, ordering }, filtQueries);
            dispatch(fetchTasksByAsset({ tableId: uniqTableId, assetId: asset.id, params: { queries } }));
            initProgresses();
        }
    }, [tableUserPrefs === null || tableUserPrefs === void 0 ? void 0 : tableUserPrefs.pageSize, page, ordering, sortBy, requestsLoading, filtersloading, filtersForQueries]);
    if (!projectId) {
        return (_jsx("div", { className: "fullWidth fullHeight flex center alignCenter lightgrey", style: { padding: 10, fontSize: 14 }, children: `You have to be in the ${asset.name} project to be able to see the tasks` }));
    }
    if (projectId && !permission(['projet_tasks__read'], undefined, undefined, projectId)) {
        return (_jsx("div", { className: "fullWidth fullHeight flex center alignCenter lightgrey", style: { padding: 10, fontSize: 14 }, children: `You don't have permission to see the tasks table.` }));
    }
    return (_jsx(TableTasks, { tableId: uniqTableId, enableStats: false, projectId: projectId, data: tasksData, loading: loading, count: count, requestsLoading: requestsLoading, assetsAttributes: assetsAttributes, progressionStatus: progressionStatus, steps: steps, projects: projects, filters: filters, progress: getProgressAverage(Object.assign(Object.assign({}, progress), { tasks: httpProgress })), page: page, setPage: setPage }));
}
export default Tasks;
